export const areaIcons = {
  register: 'library_add',
  reports: 'pie_chart',
  projects: 'view_object_track',
  projectPlanning: 'view_object_track',
  projectFinancials: 'euro',
  projectTeam: 'circles_ext',
  projectBilling: 'checkbook',
  dashboards: 'dashboard_2',
  employees: 'face',
  invoices: 'receipt_long',
  customers: 'corporate_fare',
  contacts: 'id_card',
  actions: 'add_circle',
  personalSettings: 'account_circle',
  pageSettings: 'display_settings',
  systemSettings: 'tune',
  accountSettings: 'admin_panel_settings',
  logout: 'logout',
  help: 'help',
  timeTracker: 'timer',
  personalPlanner: 'date_range',
};
